<template>
  <div class="container justify-content-center">
    <div class="row mt-3">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h5>{{ crewSchedTraining.trainingCourseName }}</h5>
          </div>
          <div class="card-body">
            <form>
              <div class="form-group row">
                <label
                  for="status"
                  class="col-md-2 col-form-label font-weight-bold"
                >STATUS:</label>
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="status"
                    placeholder="status"
                    :value="evaluate(crewSchedTraining)"
                    readonly
                    :class="{'cancelled':crewSchedTraining.cancelledAt}"
                  >
                </div>
              </div>

              <div class="form-group row">
                <label
                  for="dateFrom"
                  class="col-md-2 col-form-label font-weight-bold"
                >Date From:</label>
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="dateFrom"
                    placeholder="Date From"
                    :value="crewSchedTraining.dateFrom | moment('ddd,  MMM Do  ,YYYY')"
                    readonly
                  >
                </div>
              </div>

              <div class="form-group row">
                <label
                  for="dateTo"
                  class="col-md-2 col-form-label font-weight-bold"
                >Date To:</label>
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="dateTo"
                    placeholder="Date To"
                    :value="crewSchedTraining.dateTo | moment('ddd,  MMM Do  ,YYYY')"
                    readonly
                  >
                </div>
              </div>

              <div class="form-group row">
                <label
                  for="timeFrom"
                  class="col-md-2 col-form-label font-weight-bold"
                >TimeFrom:</label>

                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="timeFrom"
                    placeholder="Time From"
                    :value="crewSchedTraining.timeFrom | parseTime"
                    readonly
                  >
                </div>
              </div>

              <div class="form-group row">
                <label
                  for="timeTo"
                  class="col-md-2 col-form-label font-weight-bold"
                >TimeTo:</label>
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="timeTo"
                    placeholder="Time To"
                    :value="crewSchedTraining.timeTo | parseTime"
                    readonly
                  >
                </div>
              </div>

              <div class="form-group row">
                <label
                  for="contactPerson"
                  class="col-md-2 col-form-label font-weight-bold"
                >ContactPerson:</label>
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="contactPerson"
                    placeholder="Contact Person"
                    :value="crewSchedTraining.trainingProviderPerson"
                    readonly
                  >
                </div>
              </div>

              <div class="form-group row">
                <label
                  for="contactNo"
                  class="col-md-2 col-form-label font-weight-bold"
                >Contact#:</label>
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="contactNo"
                    placeholder="Contact #"
                    :value="crewSchedTraining.trainingNumber"
                    readonly
                  >
                </div>
              </div>

              <div class="form-group row">
                <label
                  for="days"
                  class="col-md-2 col-form-label font-weight-bold"
                >#Days:</label>
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="days"
                    placeholder="Time From"
                    readonly
                    :value="crewSchedTraining.days"
                  >
                </div>
              </div>

              <div class="form-group row">
                <label
                  for="hours"
                  class="col-md-2 col-form-label font-weight-bold"
                >#Hours:</label>
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="hours"
                    placeholder="Time From"
                    readonly
                    :value="crewSchedTraining.days"
                  >
                </div>
              </div>

              <div class="form-group row">
                <label
                  for="email"
                  class="col-md-2 col-form-label font-weight-bold"
                >Email:</label>
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="email"
                    placeholder="Email"
                    :value="crewSchedTraining.trainingProviderEmail"
                    readonly
                  >
                </div>
              </div>

              <div class="form-group row">
                <label
                  for="trainingCenter"
                  class="col-md-2 col-form-label font-weight-bold"
                >TrainingProvider:</label>
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="trainingCenter"
                    placeholder="Training Provider"
                    :value="crewSchedTraining.trainingProvider"
                    readonly
                  >
                </div>
              </div>

              <div class="form-group row">
                <label
                  for="venue"
                  class="col-md-2 col-form-label font-weight-bold"
                >Venue:</label>
                <div class="col-md-10">
                  <textarea
                    class="form-control"
                    id="venue"
                    rows="3"
                    :value="crewSchedTraining.venue"
                    readonly
                  />
                </div>
              </div>
            </form>
          </div>

          <div class="card-footer">
            <div class="text-center">
              <button
                class="btn btn-secondary"
                @click="goBack"
              >
                <i class="fa fa-undo" /> Go Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {formMixins} from "../../../../mixins/formMixins";
    import {mapActions, mapGetters} from "vuex";

    export default {
        props: ['id'],
        mixins:[ formMixins ],
        name: "ViewCrewScheduledTrainings",
        data() {
            return {

            }
        },

        methods: {
            ...mapActions(['viewCrewSchedTraining']),

            numberOfHours() {
                if(this.crewSchedTraining.timeFrom) {
                    let timeFrom = this.crewSchedTraining.timeFrom;
                    let timeTo = this.crewSchedTraining.timeTo;
                    let hourFrom = parseInt(timeFrom.substr(0, timeFrom.indexOf(':')));
                    let minuteFrom = parseInt(timeFrom.substr(timeFrom.indexOf(':')+1, 2));
                    let hourTo = parseInt(timeTo.substr(0, timeTo.indexOf(':')));
                    let minuteTo = parseInt(timeTo.substr(timeTo.indexOf(':')+1, 2));
                    let totalHour = hourTo - hourFrom;
                    let totalMinute = (minuteTo - minuteFrom) / 60;
                    return Math.round(totalHour + totalMinute);
                }
            },

            evaluate(crewSchedTraining) {
                if (crewSchedTraining.cancelledAt) {
                    return 'CANCELLED';
                }

                if (crewSchedTraining.wasConducted && !crewSchedTraining.trainingCompleted) {
                    return 'INCOMPLETE';

                } else if (!crewSchedTraining.wasConducted) {
                    let dateFrom = new Date(crewSchedTraining.dateFrom);
                    let dateTo = new Date(crewSchedTraining.dateTo);
                    let dateNow = new Date();
                    if (dateFrom > dateNow) {
                        console.log('PENDING');
                        return 'PENDING';

                    } else if (dateFrom >= dateNow && dateNow <= dateTo) {
                        console.log('on going');
                        return 'ON GOING';
                    } else {
                        return 'NOT YET CONDUCTED';
                    }

                } else if(!crewSchedTraining.isValid) {
                    console.log('EXPIRED');
                    return 'EXPIRED';

                } else if ( crewSchedTraining.trainingCompleted && crewSchedTraining.wasConducted) {
                    console.log('COMPLETE');
                    return 'COMPLETED';

                } else {

                    console.log('INCOMPLETE');
                    return 'INCOMPLETE';
                }
            }

        },

        computed: {
            ...mapGetters(['crewSchedTraining']),
        },

        created() {
            let crewTraining = this.id;
            this.viewCrewSchedTraining({crewTraining});
        }
    }
</script>

<style scoped>

    @media screen and (max-width: 575px) {
        label{
            font-size: 16px;
        }
        input:read-only{
            font-size: 14px;
            background-color: white;
            border-top: none;
            border-left: none;
            border-right: none;
            box-shadow: 0px;
        }
    }

    input:read-only{
        background-color: white;
        border-top: none;
        border-left: none;
        border-right: none;
        box-shadow: 0px;
    }

    #status{
        background-color: white;
        border-top: none;
        border-bottom: none;
        border-left: none;
        border-right: none;
        box-shadow: 0px;
        font-weight: bold;
    }

    label{
        font-size: 15px;
    }

    .cancelled{
        color: #ff253a;
    }
</style>